import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page">
      <div className="hdr">
        <div>
          <div className="hdr-label">Orpi Mougel Immobilier · Orpi Mougel Immobilier Pro</div>
          <div className="hdr-title">Tableau de bord KPIs</div>
          <div className="hdr-sub">La Ciotat</div>
        </div>
      </div>
      <div className="login-wrap">
        <div className="login-card">
          <div className="login-hint">Connexion</div>
          <form onSubmit={submit}>
            {err && (
              <div className="login-err" data-testid="login-error">
                {err}
              </div>
            )}
            <div className="login-field">
              <label className="form-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                data-testid="login-email-input"
              />
            </div>
            <div className="login-field">
              <label className="form-label" htmlFor="password">Mot de passe</label>
              <input
                id="password"
                type="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                data-testid="login-password-input"
              />
            </div>
            <button
              type="submit"
              className="btn btn-red"
              style={{ width: "100%", padding: "11px 18px", fontSize: 13 }}
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>
          <div
            style={{
              marginTop: 18,
              fontSize: 11,
              color: "#aaa",
              lineHeight: 1.7,
              textAlign: "center",
            }}
          >
            Un compte est requis pour accéder au tableau de bord.
            <br />
            Contactez votre directeur pour obtenir vos identifiants.
          </div>
        </div>
      </div>
    </div>
  );
}
